const alumDealerList = [
  "ABS Inc. Oxnard",
  "Hayward Lumber Santa Barbara",
  "Sierra Padre",
  "Superior Moulding",
  "Marina Sash & Lock",
  "Details Home",
  "Mancino Door & Window",
  "Coast Door & Hardware",
  "Eletel Door Supply", //my test account
  "George Dealer", // outside sales test dealer accounts
  "Arnold Dealer",
  "Brett Dealer"
] as const;

const alumEmailList = [
  "eddieg@ganahl.com"
]

function allowedAlumAccess(dealer: string, email: string) {
  const userRole = sessionStorage.getItem("role")?.replaceAll("\"", "");
  return alumDealerList.some((itm) => dealer.startsWith(itm)) || alumEmailList.includes(email) || userRole === "Admin" || userRole === "Inside Sales";
}

export default allowedAlumAccess;
